import React, {useState} from 'react';
import LoginUserModal from "../../User/LoginUserModal";
import UserDrawer from "../UserDrawer/UserDrawer";
import RoundedIcon from "../../Common/RoundedIcon";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../../reducers";
import {getUser} from "../../../services/User/reducer";
import {connect, DispatchProp} from "react-redux";
import {ReactComponent as ArrowRightIco} from "../../../../images/icons/arrow-right.svg";
import {ReactComponent as BogoOutlineIco} from "../../../../images/icons/bogo-outline.svg";
import {getStoreDefaultConfig} from "../../../services/Store/reducer";

type Props = ReturnType<typeof mapStateToProps> & DispatchProp;

const DrawerUserSection = ({user, defaultConfig}: Props) => {
    const [loginModal, setLoginModal] = useState(false);
    const [registrationModal, setRegistrationModal] = useState(false);
    const [showUserDrawer, setShowUserDrawer] = useState(false);
    const {t} = useTranslation();

    const handleShowUserDrawer = () => {
        setShowUserDrawer(true);
    }

    return (
        <>
            {loginModal && (
                <LoginUserModal onHide={() => setLoginModal(false)}/>
            )}
            {registrationModal && (
                <LoginUserModal page={"REGISTER"} onHide={() => setRegistrationModal(false)} show/>
            )}
            {showUserDrawer && (
                <UserDrawer onHide={() => setShowUserDrawer(false)} show/>
            )}
            <ul className="navbar-nav justify-content-end flex-grow-1">
                <h5>{t("modules.navbar.field.account.title")}</h5>
                {(user && user.name) ? (
                    <li className={"nav-item"}>
                        <button onClick={handleShowUserDrawer} className="nav-link">
                            <span>{t("modules.navbar.field.your_account.title")}</span>
                            <ArrowRightIco/>
                        </button>
                    </li>
                ) : (
                    <>
                        <li className={"nav-item"}>
                            <button className="nav-link" onClick={() => setLoginModal(true)}>
                                <span>{t("common.action.login")}</span>
                                <ArrowRightIco/>
                            </button>
                        </li>
                        <li className={"nav-item"}>
                            <button className="nav-link register-btn with-icon"
                                    onClick={() => setRegistrationModal(true)}>
                                <RoundedIcon icon={<BogoOutlineIco/>} size="medium" color="success"/>
                                <div className={"nav-link-multiline"}>
                                    {t("common.action.create_an_account")}
                                    <small>
                                        {defaultConfig?.loyalty?.registration?.banner_text ? defaultConfig?.loyalty?.registration?.banner_text : t("modules.navbar.field.registration_banner.title")}
                                    </small>
                                </div>
                                <ArrowRightIco/>
                            </button>
                        </li>
                    </>
                )}
            </ul>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({
    user: getUser(state.user),
    defaultConfig: getStoreDefaultConfig(state.config)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(DrawerUserSection));